// 在你的main.js或者专门存放全局配置的地方注册自定义指令
import Vue from 'vue';

Vue.directive('remove-leading', {
  bind(el, binding) {
    // 绑定阶段可以获取原始值并存储起来，但此处我们直接在update钩子中处理
    const value = binding.value;
    if (typeof value === 'string') {
      const cleanedValue = value.replace(/^[\d. ]+/, '');
      el.textContent = cleanedValue; // 如果是textContent属性
      // 或者如果是指令应用在input之类的元素上：
      // el.value = cleanedValue; // 如果是value属性
    }
  },
  update(el, binding) {
    // 当vnode更新时执行此函数
    const value = binding.value;
    if (typeof value === 'string') {
      const cleanedValue = value.replace(/^[\d. ]+/, '');
      el.textContent = cleanedValue; // 如果是textContent属性
      // 或者如果是指令应用在input之类的元素上：
      // el.value = cleanedValue; // 如果是value属性
    }
  }
});

// 然后在模板中使用这个自定义指令
// <p v-remove-leading="content">...</p>
// 或者如果是应用于input标签
// <input type="text" v-model="content" v-remove-leading />